import log from 'loglevel';
import { ApiService } from './ApiService';
import { ApiEndpoints } from '@/constants/ApiEndpoints';

import { TokenRequiredStrategy } from '../strategies/TokenRequiredStrategy';

import { Paging } from '@/interfaces/Paging';
import { PayoutStore } from '@/store/PayoutStore';
import { Country } from '@/interfaces/Payouts/Country';
import { PayoutAPIResponse } from '@/interfaces/Payouts/PayoutAPIResponse';
import { MyPayoutDataResponse } from '@/interfaces/Payouts/MyPayoutDataResponse';
import { InitiatePayoutAPIResponse } from '@/interfaces/Payouts/InitiatePayoutAPIResponse';

class PayoutServiceClass extends ApiService {




  private PAYOUT_OPTIONS = ApiEndpoints.PAYOUT_OPTIONS;
  private MY_PAYOUT_DATA = ApiEndpoints.MY_PAYOUT_DATA;


  constructor() {
    super(TokenRequiredStrategy);
  }

  private initiatePayoutEndpoint(payoutOptionId: number, payoutDenominationId: number): string {
    return `/payout_options/${payoutOptionId}/denomination/${payoutDenominationId}`;
  }




  async getAllPayoutOptions(params: Paging, selectedCountry: Country): Promise<PayoutAPIResponse> {
    try {
      const response = await this.get(this.PAYOUT_OPTIONS, {...params, country: selectedCountry.region_code});
      return response;
    } catch (error) {
      log.error('Failed to get all payout options:', error);
      throw error;
    }
  }



  async initiatePayout(payoutOptionId: number, payoutDenominationId: number, email: string): Promise<InitiatePayoutAPIResponse> {
    try {
      return await this.post(this.initiatePayoutEndpoint(payoutOptionId, payoutDenominationId), { email_input: email });
    } catch (error: any) {
      log.error('Failed to initiate payout:', error);
      throw error;
    }
  }




  async getMyPayoutData(params: Paging): Promise<MyPayoutDataResponse> {
    try {
      return await this.get(this.MY_PAYOUT_DATA, params);
    } catch (error) {
      log.error('Failed to get my payout data:', error);
      throw error;
    }
  }


}

const PayoutService = new PayoutServiceClass();
export { PayoutService };
